import * as tslib_1 from "tslib";
import React from 'react';
import BaseViewer from './Base';
import commentsTheme from '../Themes/Viewer/comments.scss';
var CommentViewer = function (props) { return (React.createElement("div", { className: 'da-editor-comments' },
    React.createElement(BaseViewer, tslib_1.__assign({ theme: commentsTheme, showMediaAlwaysSmall: true, fixedParagraph: false }, props)))); };
export default CommentViewer;
//# sourceMappingURL=Comment.js.map